import { Events } from '../events';
import type { SignalEvent } from '../types';
import { useEmitter, useListener } from '../utils';

export function useFocusSearchFieldEmitter() {
    return useEmitter<boolean>(Events.FocusSearch);
}

export function useFocusSearchFieldListener(onSignal: SignalEvent<boolean>) {
    return useListener<boolean>({
        eventName: Events.FocusSearch,
        onSignal,
    });
}
